import {
    Button,
    TextField,
    Grid,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
} from '@mui/material';

function GewichtEditDialog({ editDialog, onChange, loading, onUpdate, onClose }) {
    return (
        <Dialog open={editDialog.open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle sx={{ bgcolor: '#1f2937', color: '#e0f2fe' }}>
                Gewichtseintrag bearbeiten
            </DialogTitle>
            <DialogContent sx={{ bgcolor: '#1f2937', pt: 2 }}>
                <Grid container spacing={2}>
                    <Grid>
                        <TextField
                            fullWidth
                            label="Gewicht (kg)"
                            type="number"
                            value={editDialog.entry?.gewicht || ''}
                            onChange={(e) => onChange(prev => ({
                                ...prev,
                                entry: { ...prev.entry, gewicht: e.target.value }
                            }))}
                            inputProps={{ step: 0.1, min: 0 }}
                        />
                    </Grid>
                    <Grid>
                        <TextField
                            fullWidth
                            label="Datum"
                            type="date"
                            value={editDialog.entry?.datum || ''}
                            onChange={(e) => onChange(prev => ({
                                ...prev,
                                entry: { ...prev.entry, datum: e.target.value }
                            }))}
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                    <Grid>
                        <TextField
                            fullWidth
                            label="Notiz"
                            value={editDialog.entry?.notiz || ''}
                            onChange={(e) => onChange(prev => ({
                                ...prev,
                                entry: { ...prev.entry, notiz: e.target.value }
                            }))}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions sx={{ bgcolor: '#1f2937' }}>
                <Button onClick={onClose} sx={{ color: '#93c5fd' }}>
                    Abbrechen
                </Button>
                <Button
                    onClick={onUpdate}
                    variant="contained"
                    disabled={loading}
                    sx={{ background: 'linear-gradient(135deg, #3b82f6 0%, #1e3a8a 100%)' }}
                >
                    Speichern
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default GewichtEditDialog;
